<template>
  <router-link
    v-slot="{ href, isActive, navigate }"
    :to="to"
    custom
    active-class="active"
  >
    <li
      class="font-medium h-7 my-1 hover:bg-slate-25 hover:text-bg-50 flex items-center px-2 rounded-md dark:hover:bg-slate-800"
      :class="{
        'bg-woot-800 hover:bg-woot-800 dark:bg-slate-800': isActive,
        'text-ellipsis overflow-hidden whitespace-nowrap max-w-full': shouldTruncate,
      }"
      @click="navigate"
    >
    <a
        :href="href"
        class="inline-flex text-left max-w-full w-full items-center"
        @click="handleClick"
      >
        <span
          v-if="icon"
          class="inline-flex items-center justify-center w-5 h-5 rounded-sm bg-slate-100 dark:bg-slate-700 p-0.5 mr-1.5 rtl:mr-0 rtl:ml-1.5 inbox-childItem-Icon"
        >
          <fluent-icon
            class="text-xxs text-slate-700 dark:text-slate-200"
            :class="{
              'text-woot-500 dark:text-woot-500': isActive,
            }"
            :icon="icon"
            size="14"
            v-bind="icon === 'chat' ? { viewBox: '0 0 30 35' } : {}"
          />
        </span>

        <!-- Robot icon for automation labels -->
        <span
          v-if="labelColor && isAutomationLabel"
          class="inline-flex items-center justify-center w-4 h-4 mr-1.5 rtl:mr-0 rtl:ml-1.5"
        >
          <svg
            class="w-3.5 h-3.5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            :style="{ color: labelColor }"
          >
            <path d="M13 2v2h-2V2h2zm-1 4a6 6 0 0 0-6 6v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6a6 6 0 0 0-6-6zM8 12h2v2H8v-2zm6 0h2v2h-2v-2zm-5 5h6v2H9v-2zM2 10h2v6H2v-6zm18 0h2v6h-2v-6z"/>
          </svg>
        </span>
        <!-- Color dot for normal labels -->
        <span
          v-else-if="labelColor"
          class="inline-flex rounded-sm bg-slate-100 h-3 w-3.5 mr-1.5 rtl:mr-0 rtl:ml-1.5 border border-slate-50 dark:border-slate-900"
          :style="{ backgroundColor: labelColor }"
        />
        <div
          class="items-center flex overflow-hidden whitespace-nowrap text-ellipsis w-full justify-between"
        >
          <span
            class="text-xs text-slate-700 dark:text-slate-100  color-blue"
            :class="{
              'isActiveClass': isActive,
              'text-ellipsis overflow-hidden whitespace-nowrap max-w-full': shouldTruncate,
            }"
            :title="label.length > 25 ? label : ''"
          >
            {{ truncatedLabel }}
          </span>
          <span
            v-if="showChildCount"
            class="bg-slate-50 dark:bg-slate-700 rounded text-xxs font-medium mx-1 py-0 px-1"
            :class="
              isCountZero
                ? `text-slate-300 dark:text-slate-700`
                : `text-slate-700 dark:text-slate-50`
            "
          >
            {{ childItemCount }}
          </span>
          </div>
        <span
          v-if="warningIcon"
          class="inline-flex rounded-sm mr-1 bg-slate-100"
        >
          <fluent-icon
            v-tooltip.top-end="$t('SIDEBAR.FACEBOOK_REAUTHORIZE')"
            class="text-xxs"
            :icon="warningIcon"
            size="10"
          />
        </span>
      </a>
    </li>
  </router-link>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelColor: {
      type: String,
      default: '',
    },
    shouldTruncate: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    warningIcon: {
      type: String,
      default: '',
    },
    showChildCount: {
      type: Boolean,
      default: false,
    },
    childItemCount: {
      type: Number,
      default: 0,
    },
    parentLabel: { type: String, default: '' },
    automation: { type: Boolean, default: false },
    contactAutomation: { type: Boolean, default: false },
  },
  computed: {
    isAutomationLabel() {
      return this.automation || this.contactAutomation;
    },
    showIcon() {
      return {
        'overflow-hidden whitespace-nowrap text-ellipsis': this.shouldTruncate,
      };
    },
    isCountZero() {
      return this.childItemCount === 0;
    },
    menuTitle() {
      return this.shouldTruncate ? this.label : '';
    },
    truncatedLabel() {
      if (this.label.length > 25) {
        return this.label.slice(0, 20) + '...';
      }
      return this.label;
    },
  },
  methods: {
    handleClick() {
      this.$emit('child-click', {
        to: this.to,
        label: this.label,
        icon: this.icon,
        count: this.childItemCount,
      });
    },
  },
};
</script>
<style scoped>
.color-blue {
  color: #40518A ;
}
.inbox-childItem{
 background-color:#cadcf1;
}
body:not(.dark) .inbox-childItem-Icon{
    background-color:#cadcf1;
}
.isActiveClass{
  color: white !important;
}
</style>
